{
  "title": "Biography",
  "written_by_ai_help": "This paragraph was written by AI from facts the game recorded. The fact line above it is the record.",
  "hide": "Hide this entry",
  "hidden": "Hidden. Only you can see it.",
  "show_again": "Show this entry again",
  "regenerate": "Write this paragraph again",
  "regenerate_left": "{count, plural, one {You can do this # more time this week.} other {You can do this # more times this week.}}",
  "regenerate_none_left": "You can write paragraphs again next week.",
  "season": "Season {season}",
  "generation": "{n, selectordinal, one {#st} two {#nd} few {#rd} other {#th}} generation",
  "origin": {
    "line": "{golfer} started out in Season {season}: {path}, from {nation}.",
    "path": {
      "real_handicap": "a club golfer with a real handicap",
      "beginner": "new to the game",
      "junior": "a junior golfer",
      "senior": "a senior golfer",
      "random_life": "a life drawn at random",
      "elite_amateur": "an elite amateur",
      "tour_pro": "a professional",
      "computer_run": "a golfer of the {gameName} world"
    },
    "nation": {
      "ENG": "England",
      "SCO": "Scotland",
      "WAL": "Wales",
      "IRL": "Ireland",
      "USA": "the USA"
    }
  },
  "fact": {
    "rust_worn_off": "{golfer} shook off the rust in Season {season}.",
    "first_fl_handicap": "{golfer} earned a first FL Handicap in Season {season}.",
    "first_below_28": "{golfer} went below 28 for the first time in Season {season}.",
    "first_below_20": "{golfer} went below 20 for the first time in Season {season}.",
    "first_below_10": "{golfer} went below 10 for the first time in Season {season}.",
    "first_below_5": "{golfer} went below 5 for the first time in Season {season}.",
    "scratch": "{golfer} reached scratch in Season {season}.",
    "first_plus": "{golfer} reached a plus figure for the first time in Season {season}.",
    "first_birdie": "{golfer} made a first birdie in Season {season}.",
    "first_eagle": "{golfer} made a first eagle in Season {season}.",
    "hole_in_one": "{golfer} made a hole-in-one in Season {season}.",
    "albatross": "{golfer} made an albatross in Season {season}.",
    "first_win": "{golfer} won for the first time in Season {season}.",
    "club_champion": "{golfer} became club champion in Season {season}.",
    "course_record": "{golfer} set a course record in Season {season}.",
    "squad": "{golfer} was picked for a squad in Season {season}.",
    "team_selection": "{golfer} was picked for a team event in Season {season}.",
    "turned_pro": "{golfer} turned professional in Season {season}.",
    "tour_card": "{golfer} earned a tour card in Season {season}.",
    "first_cut": "{golfer} made a first cut in Season {season}.",
    "first_tour_win": "{golfer} won on tour for the first time in Season {season}.",
    "major_top10": "{golfer} finished in the top ten of a major in Season {season}.",
    "major_win": "{golfer} won a major in Season {season}.",
    "pro_ranking_top50": "{golfer} reached the top 50 of the FL Pro Ranking in Season {season}.",
    "pro_ranking_no1": "{golfer} reached No. 1 in the FL Pro Ranking in Season {season}.",
    "moved_home_club": "{golfer} moved to a new home club in Season {season}.",
    "swing_rebuild": "{golfer} finished a swing rebuild in Season {season}.",
    "named_rival": "{golfer} found a rival in Season {season}.",
    "birthday_18": "{golfer} turned 18 in Season {season}.",
    "birthday_50": "{golfer} turned 50 in Season {season}.",
    "adaptive_title": "{golfer} won an Adaptive Golf Series title in Season {season}.",
    "long_drive_final": "{golfer} reached the Long Drive World Final in Season {season}.",
    "hall_of_fame": "{golfer} joined the hall of fame in Season {season}.",
    "retired": "{golfer} called it a day in Season {season}.",
    "family_link": "{golfer} carried the family name on in Season {season}.",
    "handover": "{golfer} took over the family's golf in Season {season}."
  }
}
